// O Bootstrap 4.1+ limita tooltips e popovers ao "scroll parent" do gatilho (boundary
// 'scrollParent'). Nas tabelas dentro de .table-responsive, que rola no eixo x, isso é a própria
// tabela: com uma ou duas linhas, um tooltip de duas linhas não cabe nem acima nem abaixo do
// gatilho, e o Popper o empurra para cima do link. O tooltip intercepta o clique e o link não
// navega (conta com razão social longa em admin/accounts com a busca retornando uma linha).
// Com 'window' o limite é a página, como era antes da atualização para o 4.6.2.
// O Popover copia os padrões do Tooltip quando o bootstrap carrega, então os dois são ajustados.
// Um data-boundary no elemento continua valendo.
(function ($) {
  $.fn.tooltip.Constructor.Default.boundary = "window";
  $.fn.popover.Constructor.Default.boundary = "window";
})(jQuery);
